module.exports = __webpack_public_path__ + "static/media/Item_Weapon_G36C_C.7eaa1927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_G36C_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_G36C_C.png
// module chunks = 0